module.exports = __webpack_public_path__ + "img/conasi_logo.c7ef98eb.png";